import Vue from 'vue'
import Vuetify from 'vuetify'
import pt from 'vuetify/src/locale/pt.ts'
// import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify)

/**
 * Temas acessíveis com contraste adequado (WCAG AA)
 * - light: tema padrão claro
 * - dark: tema escuro
 * - highContrast: alto contraste para usuários com baixa visão
 */
const themes = {
  light: {
    primary: '#1976D2',      // Azul principal
    secondary: '#424242',     // Cinza secundário
    accent: '#82B1FF',        // Azul claro de destaque
    error: '#D32F2F',         // Vermelho erro (contraste 4.5:1)
    warning: '#F57C00',       // Laranja aviso
    info: '#1976D2',          // Azul informação
    success: '#388E3C',       // Verde sucesso (contraste 4.5:1)
    // Cores de fundo e texto
    background: '#FFFFFF',
    surface: '#FFFFFF'
  },
  dark: {
    primary: '#90CAF9',       // Azul claro
    secondary: '#B0BEC5',     // Cinza claro
    accent: '#82B1FF',
    error: '#EF5350',         // Vermelho claro
    warning: '#FFB74D',       // Laranja claro
    info: '#64B5F6',          // Azul claro
    success: '#81C784',       // Verde claro
    background: '#121212',
    surface: '#1E1E1E'
  },
  highContrast: {
    // Alto contraste: cores fortes e bem definidas
    primary: '#0D47A1',       // Azul escuro intenso
    secondary: '#000000',     // Preto
    accent: '#FFD600',        // Amarelo intenso
    error: '#B71C1C',         // Vermelho intenso
    warning: '#E65100',       // Laranja escuro
    info: '#01579B',          // Azul escuro
    success: '#1B5E20',       // Verde escuro
    background: '#FFFFFF',
    surface: '#FFFFFF'
  }
}

const opts = {
  iconfont: 'mdi',
  lang: {
    locales: { pt },
    current: 'pt'
  },
  theme: {
    dark: false, // Padrão: tema claro
    options: {
      customProperties: true // Permite CSS variables para temas
    },
    themes: {
      light: themes.light,
      dark: themes.dark
    }
  }
}

// Instância do Vuetify
const vuetify = new Vuetify(opts)

/**
 * Função para alternar tema
 * @param {string} themeName - 'light', 'dark' ou 'highContrast'
 */
export function setTheme(themeName) {
  if (themeName === 'dark') {
    vuetify.framework.theme.dark = true
    vuetify.framework.theme.themes.dark = themes.dark
  } else if (themeName === 'highContrast') {
    vuetify.framework.theme.dark = false
    vuetify.framework.theme.themes.light = themes.highContrast
  } else {
    vuetify.framework.theme.dark = false
    vuetify.framework.theme.themes.light = themes.light
  }
  
  // Salva preferência no localStorage
  localStorage.setItem('sysclass-theme', themeName)
}

export function loadSavedTheme() {
  const savedTheme = localStorage.getItem('sysclass-theme')
  
  if (savedTheme) {
    setTheme(savedTheme)
  }
}

export default vuetify